window.ImageBackground = function() {
    var el = this;
    var isMoving = false;
    var elsList = {};

    /**
     * @param {Event} event
     */
    el.beginMove = function(event) {
        event.preventDefault();
        isMoving = true;
        el._parent.isTransforming = true;

        var element = document.getElementById(
            'backgrounds-item-' + el.selectWorkareaId + '-' + el.selectId);

        elsList = {
            element: element,
            clipElement: document.getElementById('backgrounds-rect-' + el.selectWorkareaId + '-' + el.selectId),
            coord: el.transform.getPosition(element),
            pos: el.transform.getPosition(element),
            lastX: 0,
            lastY: 0,
            x: 0,
            y: 0,
        };
    };

    el.move = function(event) {
        if (isMoving) {
            var movementX = 0;
            var movementY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX -
                    elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY -
                    elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;
            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }

            movementX /= el.workarea.workAreaScale;
            movementY /= el.workarea.workAreaScale;

            var element = elsList.element;
            var posImageElement = el.transform.getArea(element);
            var posClipElement = el.transform.getArea(elsList.clipElement);

            if (
                posClipElement.x1 >= posImageElement.x1 + movementX
                && posClipElement.x2 <= posImageElement.x2 + movementX
                && posClipElement.y1 >= posImageElement.y1 + movementY
                && posClipElement.y2 <= posImageElement.y2 + movementY
            ) {

                elsList.x += movementX;
                elsList.y += movementY;

                var image = el._parent.workData.workareas[el.selectWorkareaId].format.backgrounds[el.selectId];

                var pos = {
                    x: parseInt(elsList.coord.x + elsList.x),
                    y: parseInt(elsList.coord.y + elsList.y),
                };

                el.transform.setPosition(element, pos.x, pos.y);

                var rotate = el.transform.getRotate(element);
                image.rotate_angle = rotate.angle;
                image.rotate_x = rotate.x;
                image.rotate_y = rotate.y;

                image.x = pos.x;
                image.y = pos.y;

                elsList.pos.x = pos.x;
                elsList.pos.y = pos.y;

                el.selection.update(element);
            }
        }
    };

    el.endMove = function() {
        if (isMoving) {
            isMoving = false;
            el.history.add();
        }
    };

    el.rotate = function(angle) {
        var element, riData;

        riData = el._parent.workData.workareas[el.selectWorkareaId].format.backgrounds[el.selectId];
        element = document.getElementById(
            'backgrounds-item-' + el.selectWorkareaId + '-' + el.selectId);

        if (!riData.hasOwnProperty('rotate_angle')) {
            riData.rotate_angle = 0;
        }

        riData.rotate_angle += angle;

        el.upImages.reinitImagePosition(el.selectWorkareaId, el.selectType, el.selectId);
        element.setAttribute('x', riData.x);
        element.setAttribute('y', riData.y);
        element.setAttribute('width', riData.width);
        element.setAttribute('height', riData.height);
        el.transform.setRotate(element, riData.rotate_angle);

        element = document.getElementById(
            'backgrounds-item-' + el.selectWorkareaId + '-' + el.selectId);
        el.selection.update(element);

        el.history.add();
    };

    el.resize = function(diff) {
        var data = {};

        var globalPos, pos = {}, workareaPos;

        var workarea = el._parent.workData.workareas[el.selectWorkareaId].format;
        var image = workarea.backgrounds[el.selectId];
        var ratio = image.width / image.height;

        globalPos = {
            x: 0,
            y: 0,
            width: workarea.width,
            height: workarea.height,
        };

        pos.x = image.x;
        pos.y = image.y;
        pos.width = image.width;
        pos.height = image.height;

        data.x = parseInt(pos.x) - diff;
        data.y = parseInt(pos.y) - parseInt(diff / ratio, 10);
        data.width = parseInt(pos.width) + 2 * diff;
        data.height = parseInt(pos.height) + parseInt(2 * diff / ratio, 10);

        workareaPos = $.extend(true, {}, data);

        updateData(el.selectWorkareaId, globalPos, data, workareaPos);

        function updateData(workareaId, globalPos, data, workareaPos)
        {
            var element = document.getElementById(
                'backgrounds-item-' + workareaId + '-' + el.selectId);
            var workarea = el._parent.workData.workareas[workareaId].format;
            var image = workarea.backgrounds[el.selectId];

            var valvePos = {
                x: data.x,
                y: data.y,
                width: data.width,
                height: data.height,
            };

            if (
                (globalPos.x >= valvePos.x &&
                    parseInt(globalPos.x) + parseInt(globalPos.width) <= parseInt(valvePos.x) +
                    parseInt(valvePos.width) &&
                    globalPos.y >= parseInt(valvePos.y) &&
                    parseInt(globalPos.y) + parseInt(globalPos.height) <= parseInt(valvePos.y) +
                    parseInt(valvePos.height))
                || image.hasOwnProperty('mask')
            ) {

                image.x = workareaPos.x;
                image.y = workareaPos.y;
                image.width = workareaPos.width;
                image.height = workareaPos.height;

                element.setAttribute('width', workareaPos.width);
                element.setAttribute('height', workareaPos.height);
                element.setAttribute('x', workareaPos.x);
                element.setAttribute('y', workareaPos.y);
            }
        }

        var element = document.getElementById(
            'backgrounds-item-' + el.selectWorkareaId + '-' + el.selectId);
        el.selection.update(element);

        el.history.add();
    };

    el.remove = function() {
        updateData(el.selectWorkareaId);

        function updateData(workareaId)
        {
            if (el._parent.hasOwnProperty('upImages')) {
                el.upImages.unsetUsedImage(
                    el.workData.workareas[workareaId].format.backgrounds[el.selectId].name);
            }

            delete el._parent.workData.workareas[workareaId].format.backgrounds[el.selectId];
        }

        el.selection.hide();
        el.history.add();
    };
};
